import React, { useState, useContext } from 'react';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { useHistory, Link } from 'react-router-dom';
import UserPool from '../../UserPool';
import { AccountContext } from '../../AccountContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import {consoleDevLog} from "../../apiConfig";

const Login = () => {
  const history = useHistory();
  const { setIsAuthenticated, setUser } = useContext(AccountContext) || { setIsAuthenticated: () => {}, setUser: () => {} };
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    const user = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        consoleDevLog('Login success:', session);
        if (setIsAuthenticated) {
          setIsAuthenticated(true);
        }
        user.getUserAttributes((err, attributes) => {
          if (!err && attributes) {
            const attrMap = {};
            attributes.forEach(attr => {
              attrMap[attr.getName()] = attr.getValue();
            });
            if (typeof window !== 'undefined' && window.AccountContext && window.AccountContext.setUser) {
              window.AccountContext.setUser(attrMap);
            }
            if (typeof setUser === 'function') {
              setUser(attrMap);
            }
          }
        });
        setLoading(false);
        consoleDevLog("Id Token: ", session.getIdToken().getJwtToken());
        consoleDevLog("Access Token: ", session.getAccessToken().getJwtToken());
        consoleDevLog("Refresh Token: ", session.getRefreshToken().getToken());
        window.localStorage.setItem('idToken', session.getIdToken().getJwtToken());
        window.localStorage.setItem('accessToken', session.getAccessToken().getJwtToken());
        window.localStorage.setItem('refreshToken', session.getRefreshToken().getToken());
        history.push('/');
      },
      onFailure: (err) => {
        console.error('Login error:', err);
        setLoginError(err.message || JSON.stringify(err));
        setLoading(false);
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        consoleDevLog('New password required:', userAttributes, requiredAttributes);
        setLoading(false);
      },
    });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh', backgroundColor: '#f5f5f5', paddingTop: '100px' }}>
      <div style={{ width: '300px', padding: '20px', border: '1px solid #ddd', backgroundColor: '#fff', borderRadius: '5px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Login</h2>
        <form onSubmit={onSubmit}>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="text"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
            />
          </div>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
            style={{ marginBottom: '15px' }}
          >
            {loading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : 'Log in'}
          </Button>
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <Link to="/signup" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Don't have an account? Sign up
            </Link>
          </div>
        </form>
        {loginError && (
          <div style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>{loginError}</div>
        )}
      </div>
    </div>
  );
};

export default Login;
